var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container",
      class: { wglogin: _vm.PROCESS_ENV.NODE_PLA === "wg" }
    },
    [
      _c("div", { staticClass: "content rightbox" }, [
        _c("header", [
          _c("div", { staticClass: "headerContent" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/login/ip_logo.png"),
                alt: ""
              },
              on: { click: _vm.toHomePage }
            }),
            _vm._v(" "),
            _c("p", [_vm._v("智慧数字知识产权服务专家")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "loginContent" }, [
          _c("div", { staticClass: "login-title" }, [
            _vm._v("登录创知汇客户端")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "qr-switcher" }, [
            _c(
              "div",
              {
                staticClass: "login-tab",
                class: { active: !_vm.isQRLogin },
                on: {
                  click: function($event) {
                    _vm.isQRLogin = false
                    _vm.loginType = 1
                  }
                }
              },
              [_vm._v("\n          账号登录\n        ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "login-tab",
                class: { active: _vm.isQRLogin },
                on: { click: _vm.changeLoginType }
              },
              [_vm._v("扫码登录")]
            )
          ]),
          _vm._v(" "),
          !_vm.isQRLogin && !_vm.bindPhone
            ? _c("div", [
                _c("p", { staticClass: "title flex-around" }, [
                  _vm.loginType === 1 || _vm.loginType === 2
                    ? _c(
                        "span",
                        {
                          class: { active: _vm.loginType === 1 },
                          on: {
                            click: function($event) {
                              return _vm.changeType(1, "loginForm")
                            }
                          }
                        },
                        [_vm._v("账号登录")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType === 1 || _vm.loginType === 2
                    ? _c(
                        "span",
                        {
                          class: { active: _vm.loginType === 2 },
                          on: {
                            click: function($event) {
                              return _vm.changeType(2, "loginForm")
                            }
                          }
                        },
                        [_vm._v("验证码登录")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType === 3
                    ? _c("span", { staticClass: "active" }, [
                        _vm._v("注册账号")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loginType === 4
                    ? _c("span", { staticClass: "active" }, [
                        _vm._v("修改密码")
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { key: "box", staticClass: "box" },
                  [
                    _c(
                      "Form",
                      {
                        ref: "loginForm",
                        attrs: {
                          model: _vm.loginForm,
                          rules: _vm.loginRule,
                          inline: ""
                        }
                      },
                      [
                        _vm.loginType === 1
                          ? _c(
                              "FormItem",
                              { attrs: { prop: "mobile" } },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: "text",
                                    placeholder: "请输入您的手机号"
                                  },
                                  model: {
                                    value: _vm.loginForm.mobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "mobile", $$v)
                                    },
                                    expression: "loginForm.mobile"
                                  }
                                })
                              ],
                              1
                            )
                          : _c(
                              "FormItem",
                              { attrs: { prop: "mobile" } },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: "text",
                                    autocomplete: "off",
                                    placeholder: "请输入您的手机号"
                                  },
                                  model: {
                                    value: _vm.loginForm.mobile,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "mobile", $$v)
                                    },
                                    expression: "loginForm.mobile"
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.loginType === 1
                          ? _c(
                              "FormItem",
                              { attrs: { prop: "password" } },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: "password",
                                    placeholder: "请输入你的密码",
                                    password: ""
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loginType === 1
                          ? _c(
                              "FormItem",
                              [
                                _c("sliding-validation", {
                                  ref: "alidationModal",
                                  attrs: { scene: "nc_login" },
                                  on: { validationData: _vm.getValidationData }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loginType === 2 ||
                        _vm.loginType === 4 ||
                        _vm.loginType === 3
                          ? _c(
                              "FormItem",
                              {
                                key: "loginForm.code",
                                attrs: { prop: "code" }
                              },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: "number",
                                    autocomplete: "off",
                                    placeholder: "请输入验证码"
                                  },
                                  model: {
                                    value: _vm.loginForm.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "code", $$v)
                                    },
                                    expression: "loginForm.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "Button",
                                  {
                                    staticClass: "login-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getVerificationCode(
                                          _vm.loginType
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.btLogin) + " ")]
                                ),
                                _vm._v(" "),
                                _vm.smsValidation
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ivu-poptip-popper",
                                          staticStyle: {
                                            position: "absolute",
                                            "will-change": "top, left",
                                            top: "24px",
                                            left: "0px",
                                            width: "100%"
                                          },
                                          attrs: { "x-placement": "bottom-end" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "ivu-poptip-content"
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "ivu-poptip-arrow"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ivu-poptip-inner"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ivu-poptip-title"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ivu-poptip-title-inner"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          滑块验证\n                          "
                                                          ),
                                                          _c("img", {
                                                            staticStyle: {
                                                              width: "10px",
                                                              height: "10px",
                                                              cursor: "pointer",
                                                              float: "right",
                                                              "margin-right":
                                                                "0px",
                                                              "margin-top":
                                                                "5px"
                                                            },
                                                            attrs: {
                                                              src: require("@/assets/images/common/close.png"),
                                                              alt: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.smsValidation = false
                                                              }
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ivu-poptip-body",
                                                      staticStyle: {
                                                        padding: "20px 16px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ivu-poptip-body-content",
                                                          staticStyle: {
                                                            overflow: "hidden"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ivu-poptip-body-content-inner"
                                                            },
                                                            [
                                                              _c(
                                                                "sliding-validation",
                                                                {
                                                                  ref:
                                                                    "alidationBindPhoneModal",
                                                                  attrs: {
                                                                    scene:
                                                                      "nc_message"
                                                                  },
                                                                  on: {
                                                                    validationData:
                                                                      _vm.getValidationData
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loginType === 4 || _vm.loginType === 3
                          ? _c(
                              "FormItem",
                              { attrs: { prop: "password" } },
                              [
                                _c("Input", {
                                  attrs: {
                                    type: "password",
                                    autocomplete: "new-password",
                                    placeholder: "请输入你的密码",
                                    password: ""
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.loginType === 4
                                  ? _c("div", { staticClass: "warm-prompt" })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loginType === 4 || _vm.loginType === 3
                          ? _c(
                              "Radio",
                              {
                                model: {
                                  value: _vm.agreementRadio,
                                  callback: function($$v) {
                                    _vm.agreementRadio = $$v
                                  },
                                  expression: "agreementRadio"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    _vm._v("同意并遵守\n                "),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: { color: "#1e84fc" },
                                        on: {
                                          click: function($event) {
                                            return _vm.jumpPage(
                                              "/userAgreement"
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("《服务协议》")]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "FormItem",
                          { staticClass: "login-register-btn" },
                          [
                            _vm.loginBtnText == "注册"
                              ? _c(
                                  "Button",
                                  {
                                    directives: [
                                      {
                                        name: "sensors",
                                        rawName: "v-sensors",
                                        value: {
                                          type: "RegisterButtonClick",
                                          event: "click"
                                        },
                                        expression:
                                          "{ type: 'RegisterButtonClick', event: 'click' }"
                                      }
                                    ],
                                    key: "btn1",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSubmit(
                                          _vm.loginType,
                                          "loginForm"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.loginBtnText))]
                                )
                              : _vm.loginBtnText == "登录"
                              ? _c(
                                  "Button",
                                  {
                                    directives: [
                                      {
                                        name: "sensors",
                                        rawName: "v-sensors",
                                        value: {
                                          type: "RoginButtonClick",
                                          event: "click"
                                        },
                                        expression:
                                          "{ type: 'RoginButtonClick', event: 'click' }"
                                      }
                                    ],
                                    key: "btn2",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSubmit(
                                          _vm.loginType,
                                          "loginForm"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.loginBtnText))]
                                )
                              : _c(
                                  "Button",
                                  {
                                    key: "btn3",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleSubmit(
                                          _vm.loginType,
                                          "loginForm"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.loginBtnText))]
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.loginType === 3 || _vm.loginType === 4
                          ? _c("p", { staticClass: "flex-between" }, [
                              _c("span", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.changeType(1, "loginForm")
                                      }
                                    }
                                  },
                                  [_vm._v("去登录")]
                                )
                              ])
                            ])
                          : _c("p", { staticClass: "flex-between" }, [
                              _c("span", [
                                _c(
                                  "span",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.changeType(3, "loginForm")
                                      }
                                    }
                                  },
                                  [_vm._v("立即注册")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.changeType(4, "loginForm")
                                    }
                                  }
                                },
                                [_vm._v(" 忘记密码 ")]
                              )
                            ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isQRLogin && !_vm.bindPhone
            ? _c("div", { staticClass: "qr-login" }, [
                _c(
                  "div",
                  { staticClass: "QRimg" },
                  [
                    _c("a-spin", { attrs: { spinning: _vm.wxQRcodeLoading } }, [
                      _c("div", { staticStyle: { height: "236px" } }, [
                        !_vm.wxQRcodeLoading
                          ? _c("img", {
                              attrs: {
                                src: _vm.wxQRcode,
                                alt: "正在加载..",
                                height: "236"
                              }
                            })
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.isStale
                      ? _c(
                          "div",
                          {
                            staticClass: "stale-box",
                            on: { click: _vm.refreshCode }
                          },
                          [
                            _c("P", [_vm._v("二维码已过期")]),
                            _vm._v(" "),
                            _c("Button", { attrs: { type: "error" } }, [
                              _vm._v("请刷新二维码")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.qrStatus === 1
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "flex-center",
                          staticStyle: {
                            gap: "4px",
                            "font-size": "20px",
                            color: "#29c84e",
                            "margin-bottom": "4px"
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "icon icon-tabler icons-tabler-filled icon-tabler-circle-check",
                              staticStyle: { width: "20px" },
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  stroke: "none",
                                  d: "M0 0h24v24H0z",
                                  fill: "none"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("扫码成功")])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [_vm._v("请在创知汇小程序端确认操作")])
                    ])
                  : _c("div", { staticClass: "tips" }, [
                      _vm._v("请您使用微信扫码"),
                      _c("br"),
                      _vm._v("授权登录后直接完成登录/注册")
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bindPhone
            ? _c("div", { key: "bind-box", staticClass: "bind-box" }, [
                _c("div", { staticClass: "title flex-around" }, [
                  _c("span", { staticClass: "active" }, [_vm._v("绑定手机")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [
                      _c(
                        "Form",
                        {
                          ref: "loginForm",
                          attrs: {
                            model: _vm.loginForm,
                            rules: _vm.loginRule,
                            inline: ""
                          }
                        },
                        [
                          _c(
                            "FormItem",
                            { attrs: { prop: "mobile" } },
                            [
                              _c("Input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入您的手机号"
                                },
                                model: {
                                  value: _vm.loginForm.mobile,
                                  callback: function($$v) {
                                    _vm.$set(_vm.loginForm, "mobile", $$v)
                                  },
                                  expression: "loginForm.mobile"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "FormItem",
                            { attrs: { prop: "password" } },
                            [
                              _c("Input", {
                                attrs: {
                                  type: "password",
                                  placeholder: "请输入你的密码",
                                  password: ""
                                },
                                model: {
                                  value: _vm.loginForm.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.loginForm, "password", $$v)
                                  },
                                  expression: "loginForm.password"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "FormItem",
                            { attrs: { prop: "code" } },
                            [
                              _c("Input", {
                                attrs: {
                                  type: "number",
                                  autocomplete: "off",
                                  placeholder: "请输入验证码"
                                },
                                model: {
                                  value: _vm.loginForm.code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.loginForm, "code", $$v)
                                  },
                                  expression: "loginForm.code"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "Button",
                                {
                                  staticClass: "login-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.getVerificationCode(5)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.btLogin) + " ")]
                              ),
                              _vm._v(" "),
                              _vm.smsValidation
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ivu-poptip-popper",
                                        staticStyle: {
                                          position: "absolute",
                                          "will-change": "top, left",
                                          top: "24px",
                                          left: "0px",
                                          width: "100%"
                                        },
                                        attrs: { "x-placement": "bottom-end" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ivu-poptip-content" },
                                          [
                                            _c("div", {
                                              staticClass: "ivu-poptip-arrow"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "ivu-poptip-inner"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ivu-poptip-title"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ivu-poptip-title-inner"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            滑块验证\n                            "
                                                        ),
                                                        _c("img", {
                                                          staticStyle: {
                                                            width: "10px",
                                                            height: "10px",
                                                            cursor: "pointer",
                                                            float: "right",
                                                            "margin-right":
                                                              "0px",
                                                            "margin-top": "5px"
                                                          },
                                                          attrs: {
                                                            src: require("@/assets/images/common/close.png"),
                                                            alt: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.smsValidation = false
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "ivu-poptip-body",
                                                    staticStyle: {
                                                      padding: "20px 16px"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ivu-poptip-body-content",
                                                        staticStyle: {
                                                          overflow: "hidden"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ivu-poptip-body-content-inner"
                                                          },
                                                          [
                                                            _c(
                                                              "sliding-validation",
                                                              {
                                                                attrs: {
                                                                  scene:
                                                                    "nc_message"
                                                                },
                                                                on: {
                                                                  validationData:
                                                                    _vm.getValidationData
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "FormItem",
                            [
                              _c(
                                "Button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleSubmit(5, "loginForm")
                                    }
                                  }
                                },
                                [_vm._v("确定绑定")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "back-login",
                              on: {
                                click: function($event) {
                                  _vm.bindPhone = false
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/login/reback.png"),
                                  alt: ""
                                }
                              }),
                              _vm._v("返回登录\n              ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.PROCESS_ENV.NODE_PLA === "kby"
          ? _c("p", { staticClass: "bottomBox" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpPage("/userAgreement")
                    }
                  }
                },
                [_vm._v("《服务协议》")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.jumpPage("/privacyPolicy")
                    }
                  }
                },
                [_vm._v("《隐私策略》")]
              ),
              _vm._v(
                " Copyright 2024 深圳市创界通科技有限公司. All Rights\n      Reserved."
              ),
              _c(
                "a",
                {
                  attrs: { href: "http://beian.miit.gov.cn/", target: "_blank" }
                },
                [_vm._v("粤ICP备2024268789号-1")]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.PROCESS_ENV.NODE_PLA === "wg"
          ? _c("p", { staticClass: "bottomBox" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.htmlUrl + "agreementwg.html",
                    target: "_blank"
                  }
                },
                [_vm._v("《盛骁科技用户协议》")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.htmlUrl + "privacyagreementwg.html",
                    target: "_blank"
                  }
                },
                [_vm._v("《盛骁科技隐私政策》")]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffa3942e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa3942e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/loginIndex.vue
// module id = null
// module chunks = 